<page-header
  [title]="(editMode ? 'Edit ' : 'New ') + constants.strings.location"
  [subtitle]="subtitle"
></page-header>

<form [formGroup]="form" *ngIf="!loading">
  <div
    [ngStyle]="{
      justifyContent:
        editMode && location.qrCode?.url ? 'space-between' : 'flex-end',
    }"
    style="display: flex; margin-bottom: 10px"
  >
    <app-primary-button
      *ngIf="editMode && location?.qrCode?.url"
      [title]="constants.strings.downloadQRCode"
      [disabled]="loading"
      [tooltip]="tooltip"
      (tapped)="openQRCode()"
      [icon]="'qr_code'"
    ></app-primary-button>

    <div style="display: flex" *ngIf="canEditLocation">
      <app-primary-button
        [title]="constants.strings.cancel"
        border=" 1px solid var(--app-container)"
        bgColor="transparent"
        color="white"
        (tapped)="back()"
      ></app-primary-button>

      <div style="margin-left: 10px">
        <app-primary-button
          title="Save"
          border=" 1px solid var(--app-container)"
          [disabled]="loading || !canCreateLocation"
          [tooltip]="tooltip"
          (tapped)="save()"
        ></app-primary-button>
      </div>
    </div>
  </div>

  <div class="row" style="margin-bottom: 70px">
    <div class="col-lg-6">
      <div class="detail-container" id="left">
        <div class="form-field">
          <div class="form-field-label">
            Address<span style="color: red">*</span>
          </div>
          <input
            class="form-input"
            [readOnly]="true"
            placeholder="e.g. 123 High St, London, E1 AAB"
            autocomplete="off"
            [formControl]="addressFormControl"
            type="text"
            (click)="openAddressDialog()"
            [ngStyle]="{
              border:
                addressFormControl.invalid && submitted
                  ? '1px solid red'
                  : '1px solid var(--app-light-grey)',
            }"
          />
        </div>

        <div class="form-field" style="margin-top: 20px">
          <div class="form-field-label">
            Location Name<span style="color: red">*</span>
          </div>
          <input
            class="form-input"
            placeholder="e.g. Brew Haven - High St"
            autocomplete="off"
            [formControl]="nameFormControl"
            type="text"
            [ngStyle]="{
              border:
                nameFormControl.invalid && submitted
                  ? '1px solid red'
                  : '1px solid var(--app-light-grey)',
            }"
          />
        </div>
        <div class="form-field" style="margin-top: 20px">
          <div class="form-field-label">
            Description<span style="color: red">*</span>
          </div>
          <textarea
            class="form-input"
            autocomplete="off"
            [formControl]="descriptionFormControl"
            placeholder="e.g. Welcome to Brew Haven Coffee Co, where the aroma of freshly brewed coffee fills the air, and every cup tells a story."
            type="text"
            oninput="
              javascript: if (this.value.length > this.maxLength)
                this.value = this.value.slice(0, this.maxLength);
            "
            [maxlength]="1000"
            [rows]="3"
            [ngStyle]="{
              border:
                descriptionFormControl.invalid && submitted
                  ? '1px solid red'
                  : '1px solid var(--app-light-grey)',
            }"
          ></textarea>
        </div>
        <div class="form-field" style="margin-top: 20px">
          <div
            class="form-field-label"
            style="display: flex; justify-content: space-between"
          >
            <span style="margin-bottom: 0px">Tags</span
            ><span
              (click)="generateTags()"
              class="ai-button"
              [ngStyle]="{
                cursor: descriptionFormControl.value
                  ? 'pointer'
                  : 'not-allowed',
              }"
              [matTooltip]="
                descriptionFormControl.value
                  ? ''
                  : 'Please enter a description first'
              "
              >✨ Generate Tags</span
            >
          </div>

          <mat-form-field appearance="outline" class="example-chip-list">
            <mat-chip-grid #chipGrid aria-label="Enter tags">
              <mat-chip-row
                *ngFor="let fruit of tags"
                (removed)="remove(fruit)"
                [editable]="false"
                [aria-description]="'press enter to edit ' + fruit.name"
              >
                {{ fruit.name }}
                <button
                  matChipRemove
                  [attr.aria-label]="'remove ' + fruit.name"
                >
                  <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
                </button>
              </mat-chip-row>
              <input
                [placeholder]="
                  tags.length
                    ? ''
                    : 'e.g. Coffee (start typing then press enter)'
                "
                class="form-input"
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="add($event)"
              />
            </mat-chip-grid>
          </mat-form-field>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <div class="form-field" style="margin-top: 20px">
              <div class="form-field-label">WIFI Name<span></span></div>
              <input
                class="form-input"
                autocomplete="off"
                [formControl]="ssidFormControl"
                type="text"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-field" style="margin-top: 20px">
              <div class="form-field-label">WIFI Password</div>
              <input
                class="form-input"
                autocomplete="off"
                [formControl]="wifiFormControl"
                type="text"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6" style="margin-top: 20px">
            <div class="form-field">
              <div class="form-field-label">Email Address</div>
              <input
                class="form-input"
                autocomplete="off"
                [formControl]="emailFormControl"
                type="email"
              />
            </div>
          </div>

          <div class="col-lg-6" style="margin-top: 20px">
            <div class="form-field">
              <div class="form-field-label">Phone Number</div>

              <div style="display: flex; align-items: center">
                <div class="country-code-selector" [matMenuTriggerFor]="menu">
                  {{ this.selectedCountry?.emoji
                  }}<span style="margin-left: 5px">{{
                    this.selectedCountry?.dialCode ?? "+44"
                  }}</span>
                </div>

                <input
                  class="form-input"
                  autocomplete="off"
                  [formControl]="phoneFormControl"
                  type="text"
                  [maxlength]="15"
                  oninput="
                    javascript: if (this.value.length > this.maxLength)
                      this.value = this.value.slice(0, this.maxLength);
                  "
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 20px">
          <div class="col-lg-6">
            <div class="form-field">
              <div class="form-field-label">Website</div>
              <input
                class="form-input"
                autocomplete="off"
                [formControl]="websiteFormControl"
                type="text"
              />
            </div>
          </div>
          <!-- <div class="col-lg-6">
            <div class="form-field" style="margin-top: 20px">
              <div class="form-field-label">WIFI Code</div>
              <input
                class="form-input"
                autocomplete="off"
                [formControl]="wifiFormControl"
                type="text"
              />
            </div>
          </div> -->
        </div>

        <div style="display: flex; align-items: center; margin-top: 20px">
          <div
            class="form-field-label"
            style="margin-bottom: 0px; margin-right: 5px"
          >
            Social Links
          </div>
          <mat-icon
            class="status-icon"
            style="color: var(--app-timber); cursor: pointer"
            (click)="openSocialDialog()"
            >add_circle</mat-icon
          >
        </div>
        <div
          class="social-container"
          *ngFor="let item of socials"
          style="
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
          "
        >
          <div style="display: flex; align-items: center">
            <img
              [src]="
                '../assets/social/' + (item.type.name ?? item.type) + '.png'
              "
              style="margin-right: 10px"
            />
            <div
              class="form-field-label"
              style="
                margin-bottom: 0px !important;
                color: black;
                font-size: 14px;
                font-weight: normal;
              "
            >
              {{
                buildLink(item.handle, item.type.name ?? item.type).replace(
                  "https://",
                  ""
                )
              }}
            </div>
          </div>

          <div>
            <mat-icon
              style="
                color: var(--app-timber);
                cursor: pointer;
                margin-right: 5px;
              "
              (click)="
                openSocialDialog(item.handle, item.type.name ?? item.type)
              "
              >edit</mat-icon
            >
            <mat-icon
              style="color: red; cursor: pointer"
              (click)="removeSocial(item)"
              >delete</mat-icon
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="detail-container" id="right">
        <div style="display: flex; justify-content: space-between">
          <div
            class="section-title clickable"
            style="display: flex; align-items: center; gap: 8px"
          >
            <div class="form-field-label" style="margin-bottom: 0px">
              {{ defaultOpeningTimesName }}
            </div>

            <mat-icon
              *ngIf="openingTimesGroups?.length"
              (click)="editDefaultOpeningTimesName()"
              style="
                font-size: 18px;
                height: 18px;
                width: 18px;
                cursor: pointer;
              "
              >edit</mat-icon
            >
          </div>
          <div *ngIf="location.address?.country === 'United Kingdom'">
            <mat-slide-toggle
              [disabled]="false"
              [checked]="gmt"
              (change)="gmt = !gmt"
              ><span class="section-subtitle"> {{ gmt ? "GMT" : "BST" }}</span>
            </mat-slide-toggle>
          </div>
        </div>

        <div class="opening-times">
          <div
            *ngFor="let day of gmt ? openingTimes : altOpeningTimes"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
              height: 40.95px;
            "
          >
            <div style="display: flex; align-items: center">
              <mat-checkbox
                class="checkbox"
                style="margin-right: 10px"
                [checked]="day.active"
                (change)="toggleDay(day, $event.checked)"
              >
              </mat-checkbox>
              <p class="day-label">
                {{ (isHandset$ | async) ? day.label : day.day }}
              </p>
            </div>

            <div *ngIf="!day.active">
              <p class="day-label">Closed</p>
            </div>

            <div *ngIf="day.active">
              <input
                style="margin-right: 10px"
                class="small-form-input"
                autocomplete="off"
                [formControl]="day.fromControl"
                type="time"
                (change)="timeChanged()"
                [ngStyle]="{
                  border:
                    day.fromControl.invalid && submitted
                      ? '1px solid red'
                      : '1px solid var(--app-light-grey)',
                }"
              />
              <input
                class="small-form-input"
                autocomplete="off"
                [formControl]="day.toControl"
                [value]="day.toControl.value"
                type="time"
                (change)="timeChanged()"
                [ngStyle]="{
                  border:
                    day.toControl.invalid && submitted
                      ? '1px solid red'
                      : '1px solid var(--app-light-grey)',
                }"
              />
            </div>
          </div>
        </div>

        <mat-expansion-panel
          *ngIf="openingTimesGroups.length > 0"
          [expanded]="false"
        >
          <mat-expansion-panel-header>
            <mat-panel-title
              class="d-flex justify-content-between align-items-center w-100"
            >
              <div class="form-field-label mb-0">Additional Opening Times</div>
              <button
                mat-button
                color="primary"
                (click)="addOpeningTimesGroup($event)"
              >
                <mat-icon>add</mat-icon> Add Group
              </button>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div
            *ngFor="let group of openingTimesGroups; let i = index"
            class="mt-3"
          >
            <mat-card style="box-shadow: none !important">
              <mat-card-header>
                <div
                  class="d-flex justify-content-between w-100 align-items-center"
                >
                  <div>
                    <h3 class="mb-0" style="font-weight: bold">
                      {{ group.name }}
                    </h3>
                  </div>
                  <div>
                    <button
                      mat-icon-button
                      color="primary"
                      (click)="editOpeningTimesGroup(i, $event)"
                      class="me-2"
                    >
                      <mat-icon
                        style="
                          color: var(--app-timber);
                          cursor: pointer;
                          margin-right: 5px;
                        "
                        >edit</mat-icon
                      >
                    </button>
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="removeOpeningTimesGroup(i)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-header>

              <mat-card-content>
                <div class="opening-times mt-3">
                  <div
                    *ngFor="
                      let day of gmt
                        ? group.openingTimes
                        : group.altOpeningTimes
                    "
                    class="d-flex justify-content-between align-items-center mb-2"
                  >
                    <div class="d-flex align-items-center">
                      <p class="day-label mb-0">{{ day.day }}</p>
                    </div>
                    <div *ngIf="!day.active">
                      <p class="day-label mb-0">Closed</p>
                    </div>
                    <div *ngIf="day.active">
                      {{ day.fromControl.value }} - {{ day.toControl.value }}
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-expansion-panel>

        <div
          *ngIf="openingTimesGroups.length === 0"
          class="d-flex justify-content-between align-items-center"
        >
          <div class="form-field-label">Additional Opening Times</div>
          <button mat-button color="primary" (click)="addOpeningTimesGroup()">
            <mat-icon>add</mat-icon> Add Group
          </button>
        </div>
      </div>
      <div class="detail-container" id="right" style="margin-top: 20px">
        <div class="form-field-label" style="margin-bottom: 20px">
          Cover Image
        </div>
        <file-upload
          (fileSelected)="selectedCover = $event"
          [readerResult]="initialCoverUrl ?? ''"
          [rounded]="true"
        ></file-upload>

        <div style="margin-top: 20px" *ngIf="showCustomBrandingOption">
          <mat-radio-group
            [value]="selectedLogoOption"
            aria-label="Select an option"
            (change)="selectedLogoOption = $event.value"
          >
            <div class="form-field-label" style="text-align: left">
              Display logo
            </div>
            <div
              *ngFor="let option of options"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-left: 20px;
              "
            >
              <span>{{ option.label }}</span>
              <mat-radio-button [value]="option.value"></mat-radio-button>
            </div>

            <file-upload
              *ngIf="selectedLogoOption == constants.locationLogo.location"
              (fileSelected)="selectedLogo = $event"
              [readerResult]="initialLogoUrl ?? ''"
              [rounded]="true"
              [aspectRatio]="1 / 1"
            ></file-upload>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
</form>

<loader [loading]="fetchingTags"></loader>
<loader [loading]="loading || saving"></loader>

<mat-menu #menu="matMenu" class="custom-menu">
  <input
    (click)="$event.stopPropagation()"
    class="search-input"
    autocomplete="off"
    [formControl]="searchFormControl"
    type="text"
    placeholder="Search..."
    (ngModelChange)="onTypeSearch()"
  />
  <ng-template matMenuContent>
    <div
      *ngFor="let item of searchActive ? filteredCountryCodes : countryCodes"
    >
      <button
        [disabled]="false"
        class="menu-list-item"
        style="border-radius: 5px; cursor: pointer"
        [ngStyle]="{
          'font-weight': item.code === selectedCountry?.code ? '500' : 'normal',
          'background-color':
            item.code === selectedCountry?.code ? '#eeeeee' : 'transparent',
        }"
        (click)="onSelectCountryCode(item)"
        mat-menu-item
      >
        {{ item.emoji }}
        <span class="menu-list-item-label"
          >{{ item.name }} ({{ item.dialCode }})</span
        >
      </button>
    </div>
  </ng-template>
</mat-menu>
